import BaseService from '../BaseService'
import axios from "axios";

class UserMarketPlaceService extends BaseService {
    constructor() {
        super('/user-marketplaces');
    }

    updateBusinessEmail({id, payload}) {
        return axios.put(`api/v1/update-business-email/${id}`, payload)
    }

    updateMarketplaceList({payload}) {
        return axios.post(`api/v1/update-marketplace-list`, payload)
    }

    updateMarketplaceStatus({id, payload}) {
        return axios.put(`api/v1/update-marketplace-status/${id}`, payload)
    }
}

export default new UserMarketPlaceService()
